// React Library
import React from 'react';

// FontAwesome Library and importing icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCirclePlus,
    faCircleUser,
    faBars,
    faChevronDown,
    faAnglesUp,
    faEllipsisVertical,
    faCalendarDays,
    faLocationDot,
    faClock,
    faMagnifyingGlass,
    faTicket,
    faCircleInfo,
    faIndianRupeeSign,
    faStar,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronLeft,
    faChevronRight,
    faChartLine,
    faRightFromBracket,
    faGear,
    faHourglassEnd,
    faCalendarPlus,
    // faFilter,
    faArrowUpWideShort,
    faTrash,
    faXmark,
    faSliders,
    faHeart,
    faShareNodes,
    faCopy,
    faCircleExclamation,
    faDesktop,
    faChevronUp,
    faLock,
    faEarthAmericas,
    faCircleCheck,
    faPenToSquare,
    faStopwatch,
    faStamp
} from '@fortawesome/free-solid-svg-icons';
import { faSquareCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import {
    faInstagram,
    faFacebook,
    faLinkedin,
    faWhatsapp,
    faFacebookMessenger,
    faXTwitter
} from '@fortawesome/free-brands-svg-icons';

// Exporting the icons
export const CirclePlusIcon = (props) => <FontAwesomeIcon icon={faCirclePlus} {...props} />;
export const AnglesUp = (props) => <FontAwesomeIcon icon={faAnglesUp} {...props} />;
export const SquareCheckIcon = (props) => <FontAwesomeIcon icon={faSquareCheck} {...props} />;
export const CircleXmarkIcon = (props) => <FontAwesomeIcon icon={faCircleXmark} {...props} />;
export const CircleUserIcon = (props) => <FontAwesomeIcon icon={faCircleUser} {...props} />;
export const BarsIcon = (props) => <FontAwesomeIcon icon={faBars} {...props} />;
export const ChevronDownIcon = (props) => <FontAwesomeIcon icon={faChevronDown} {...props} />;
export const InstagramIcon = (props) => <FontAwesomeIcon icon={faInstagram} {...props} />;
export const FacebookIcon = (props) => <FontAwesomeIcon icon={faFacebook} {...props} />;
export const LinkedinIcon = (props) => <FontAwesomeIcon icon={faLinkedin} {...props} />;
export const EllipsisVerticalIcon = (props) => (
    <FontAwesomeIcon icon={faEllipsisVertical} {...props} />
);
export const CalendarIcon = (props) => <FontAwesomeIcon icon={faCalendarDays} {...props} />;
export const LocationIcon = (props) => <FontAwesomeIcon icon={faLocationDot} {...props} />;
export const ClockIcon = (props) => <FontAwesomeIcon icon={faClock} {...props} />;
export const SearchIcon = (props) => <FontAwesomeIcon icon={faMagnifyingGlass} {...props} />;
export const TicketIcon = (props) => <FontAwesomeIcon icon={faTicket} {...props} />;
export const InfoIcon = (props) => <FontAwesomeIcon icon={faCircleInfo} {...props} />;
export const RupeeIcon = (props) => <FontAwesomeIcon icon={faIndianRupeeSign} {...props} />;
export const StarIcon = (props) => <FontAwesomeIcon icon={faStar} {...props} />;
export const LeftIcon = (props) => <FontAwesomeIcon icon={faChevronCircleLeft} {...props} />;
export const RightIcon = (props) => <FontAwesomeIcon icon={faChevronCircleRight} {...props} />;
export const Logout = (props) => <FontAwesomeIcon icon={faRightFromBracket} {...props} />;
export const Dashboard = (props) => <FontAwesomeIcon icon={faChartLine} {...props} />;
export const SettingIcon = (props) => <FontAwesomeIcon icon={faGear} {...props} />;
export const DurationIcon = (props) => <FontAwesomeIcon icon={faHourglassEnd} {...props} />;
export const MultipleDates = (props) => <FontAwesomeIcon icon={faCalendarPlus} {...props} />;
export const FilterIcon = (props) => <FontAwesomeIcon icon={faSliders} {...props} />;
export const SortByIcon = (props) => <FontAwesomeIcon icon={faArrowUpWideShort} {...props} />;
export const TrashIcon = (props) => <FontAwesomeIcon icon={faTrash} {...props} />;
export const CloseIcon = (props) => <FontAwesomeIcon icon={faXmark} {...props} />;
export const ChevronLeftIcon = (props) => <FontAwesomeIcon icon={faChevronLeft} {...props} />;
export const ChevronRightIcon = (props) => <FontAwesomeIcon icon={faChevronRight} {...props} />;
export const ChevronUpIcon = (props) => <FontAwesomeIcon icon={faChevronUp} {...props} />;
export const HeartIcon = (props) => <FontAwesomeIcon icon={faHeart} {...props} />;
export const ShareIcon = (props) => <FontAwesomeIcon icon={faShareNodes} {...props} />;
export const CopyIcon = (props) => <FontAwesomeIcon icon={faCopy} {...props} />;
export const WhatsappIcon = (props) => <FontAwesomeIcon icon={faWhatsapp} {...props} />;
export const FacebookMessenger = (props) => (
    <FontAwesomeIcon icon={faFacebookMessenger} {...props} />
);
export const Xtwitter = (props) => <FontAwesomeIcon icon={faXTwitter} {...props} />;
export const ErrorIcon = (props) => <FontAwesomeIcon icon={faCircleExclamation} {...props} />;
export const DashboardIcon = (props) => <FontAwesomeIcon icon={faDesktop} {...props} />;
export const PrivateIcon = (props) => <FontAwesomeIcon icon={faLock} {...props} />;
export const PublicIcon = (props) => <FontAwesomeIcon icon={faEarthAmericas} {...props} />;
export const DoneIcon = (props) => <FontAwesomeIcon icon={faCircleCheck} {...props} />;
export const EditIcon = (props) => <FontAwesomeIcon icon={faPenToSquare} {...props} />;
export const StopIcon = (props) => <FontAwesomeIcon icon={faStopwatch} {...props} />;
export const SoldOut = (props) => <FontAwesomeIcon icon={faStamp} {...props} />;
